import client from './client'

export function fetchVehicles() {
  return client.get('/api/v1/vehicles')
}

export function createVehicle(payload, photos = []) {
  const formData = new FormData()
  formData.append('vehicle[make]', payload.make)
  if (payload.equipment) formData.append('vehicle[equipment]', payload.equipment)
  photos.forEach((photo) => formData.append('photos[]', photo))
  return client.post('/api/v1/vehicles', formData)
}

export function updateVehicle(id, payload, photos = []) {
  const formData = new FormData()
  if (payload.make !== undefined) formData.append('vehicle[make]', payload.make)
  if (payload.equipment !== undefined) formData.append('vehicle[equipment]', payload.equipment)
  photos.forEach((photo) => formData.append('photos[]', photo))
  return client.patch(`/api/v1/vehicles/${id}`, formData)
}

export function deleteVehicle(id) {
  return client.delete(`/api/v1/vehicles/${id}`)
}
